import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkStatus, composeAuth, AuthError } from "../../helpers/utils";
import { logoutUser } from "./account";

export const getVersionTracking = createAsyncThunk(
  "versionTracking/getVersionTracking",
  async (_, thunkApi) => {
    try {
      const url = process.env.REACT_APP_SERVER + `/api/versionTrackings`;
      const res = await fetch(url, {
        method: "GET",
        signal: thunkApi.signal,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return thunkApi.fulfillWithValue(validateData?.data, { receivedAt: Date.now() });
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue({ message: err.message });
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState().versionTracking;
      return !state.isLoadingVersionTracking &&
        (!state.lastFetchedAt || Date.now() - state.lastFetchedAt >= 5 * 60 * 1000);
    },
  }
);
